import { useEffect, useState } from "react";
import { api } from "../../../../../services/api";
import { BioModal } from "./BioModal";
import { MoreInfoModal } from "./MoreInfoModal";
import { validateLinkedinUrl } from "../../../../../utils/validateLinkedinUrl";
import { ReactComponent as LinkedinSvg } from "../../../../../assets/svgs/linkedin.svg";
import { ReactComponent as WhatsAppSvg } from "../../../../../assets/svgs/whatsapp-alt.svg";

type ExpertInfoContainerProps = {
  id: string;
};

export type ExpertInfoData = {
  name: string;
  currentCompany?: string;
  position?: string;
  researcherAcronym?: string;
  lastContactAt?: Date | string;
  currency?: string;
  value?: string | number;
  phone: string;
};

export const ExpertInfoContainer = ({ id }: ExpertInfoContainerProps) => {
  const [expertInfoData, setExpertInfoData] = useState<ExpertInfoData>({
    name: "",
    currentCompany: "",
    position: "",
    researcherAcronym: "",
    phone: "",
    lastContactAt: undefined,
    currency: undefined,
    value: undefined,
  });

  const [expertBioText, setExpertBioText] = useState(
    "Nenhuma descrição encontrada."
  );
  const [expertLinkedin, setExpertLinkedin] = useState("");
  const [linkedinStyle, setLinkedinStyle] = useState("text-primary-light");
  const [expertWhatsApp, setExpertWhatsApp] = useState("");

  const fetchExpert = () => {
    api
      .get(`/experts/${id}`)
      .then(({ data }: any) => {
        console.log("data");
        console.log(data);
        const linkedinUrl = `https://${(data.linkedin ?? "").replace(
          /https:\/\/|http:\/\/|www./g,
          ""
        )}`;
        const linkedinClass = validateLinkedinUrl(linkedinUrl)
          ? "text-primary-light"
          : "text-grey-700";
        setExpertBioText(data.bio ?? expertBioText);
        setExpertLinkedin(linkedinUrl);
        setLinkedinStyle(linkedinClass);
        if (data.phone) {
          setExpertWhatsApp(data.phone.replace(/[+\-()\s]/g, ""));
        }

        setExpertInfoData({
          name: data?.name,
          currentCompany: data?.professionalData?.currentCompany,
          position: data?.professionalData?.position,
          phone: data?.phone,
          researcherAcronym: data?.researcherAcronym,
          lastContactAt: data?.lastContactAt,
          value: data?.professionalData?.value,
          currency: data?.professionalData?.currency,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetchExpert();
  }, []);

  return (
    <div className="flex gap-2 items-center">
      {validateLinkedinUrl(expertLinkedin) ? (
        <a
          href={expertLinkedin}
          className={linkedinStyle}
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkedinSvg />
        </a>
      ) : (
        <LinkedinSvg width={16} height={16} className={linkedinStyle} />
      )}
      {expertWhatsApp != "" ? (
        <a
          href={`https://wa.me/${expertWhatsApp}`}
          className="text-primary-light"
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsAppSvg width={18} height={18} />
        </a>
      ) : (
        <WhatsAppSvg width={18} height={18} className="text-grey-700" />
      )}

      <BioModal expertBioText={expertBioText} />
      <MoreInfoModal expertInfoData={expertInfoData} />
    </div>
  );
};
